/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import { Component, type ReactNode } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { logger } from '../../logger';

export class ErrorBoundary extends Component<
  { children: ReactNode; fallback: (props: { error: Error }) => ReactNode },
  { error: Error | null }
> {
  state = {
    error: null,
  };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    // Log error
    logger.error(error.message, {
      error,
      info,
    });

    // Send error to RUM
    datadogRum.addError(error, {
      reactErrorInfo: info,
    });
  }

  render() {
    if (this.state.error) {
      return this.props.fallback({ error: this.state.error });
    }

    return this.props.children;
  }
}
